module.exports = __webpack_public_path__ + "static/media/L-6.17462852.svg";